export const CLASES_SEMANA = [
  { id: 1, nivel: 'suave', modalidad: 'Paralelo', duracion: 18, hecha: true },
  { id: 2, nivel: 'suave', modalidad: 'Apertura', duracion: 20, hecha: true },
  { id: 3, nivel: 'estandar', modalidad: 'Paralelo', duracion: 22, hecha: false },
  { id: 4, nivel: 'estandar', modalidad: 'Apertura', duracion: 23, hecha: true },
  { id: 5, nivel: 'estandar', modalidad: 'Mixta', duracion: 24, hecha: false, recomendada: true },
];

export const EXTRAS = [
  { id: 1, nombre: 'Cómo sentarte bien en la oficina', zona: 'Vida diaria', duracion: 4, progreso: 0.45, grad: 'g1' },
  { id: 2, nombre: 'Si te duele la espalda trabajando', zona: 'Vida diaria', duracion: 3, hecha: true, grad: 'g2' },
  { id: 3, nombre: 'Estiramiento exprés de cuello y hombros', zona: 'Vida diaria', duracion: 5, grad: 'g3' },
  { id: 4, nombre: 'Activación suave al despertar', zona: 'Vida diaria', duracion: 6, progreso: 0.20, grad: 'g4' },
  { id: 9, nombre: 'Ergonomía en el coche', zona: 'Vida diaria', duracion: 5, grad: 'g1' },
  { id: 10, nombre: 'Pausa activa en el trabajo', zona: 'Vida diaria', duracion: 7, grad: 'g2' },
  { id: 11, nombre: 'Cómo cargar peso sin dañarte', zona: 'Vida diaria', duracion: 4, grad: 'g3' },
];

export const RELAJACIONES = [
  { id: 5, nombre: 'Meditación guiada de 10 minutos', zona: 'Meditación', duracion: 10, progreso: 0.30, grad: 'gmed' },
  { id: 6, nombre: 'Relajación profunda para dormir', zona: 'Relajación', duracion: 12, grad: 'gmed' },
  { id: 7, nombre: 'Respiración 4-7-8 antiestrés', zona: 'Respiración', duracion: 6, grad: 'gmed' },
  { id: 8, nombre: 'Escaneo corporal para soltar tensión', zona: 'Meditación', duracion: 15, grad: 'gmed' },
  { id: 12, nombre: 'Relajación de 5 minutos exprés', zona: 'Relajación', duracion: 5, grad: 'gmed' },
  { id: 13, nombre: 'Meditación para empezar el día', zona: 'Meditación', duracion: 8, grad: 'gmed' },
  { id: 14, nombre: 'Respiración para la ansiedad', zona: 'Respiración', duracion: 7, grad: 'gmed' },
  { id: 15, nombre: 'Visualización para soltar el cuello', zona: 'Meditación', duracion: 11, grad: 'gmed' },
];

export const CHARLAS = [
  { id: 1, nombre: 'El origen del Método Pilar Domínguez', tipo: 'Charla', duracion: 18 },
  { id: 2, nombre: 'Entrevista: postura y vida moderna', tipo: 'Entrevista', duracion: 25 },
  { id: 3, nombre: 'Qué hace diferente al Método', tipo: 'Corporativo', duracion: 9 },
  { id: 4, nombre: 'Bienvenida de Pilar a la comunidad', tipo: 'Corporativo', duracion: 4 },
];

export const PAUTAS = [
  { id: 1, nombre: 'Báscula pélvica', zona: 'Lumbar', series: 3, reps: '10', hecha: true },
  { id: 2, nombre: 'Puente de glúteos', zona: 'Core', series: 3, reps: '12', progreso: 0.35 },
  { id: 3, nombre: 'Estiramiento gato-camello', zona: 'Movilidad', series: 2, reps: '8' },
  { id: 4, nombre: 'Estiramiento de psoas', zona: 'Cadera', series: 2, reps: '30s' },
];

export const NOVEDADES = [
  { id: 1, tipo: 'Clases de la semana', titulo: 'Ya están tus 5 clases de esta semana', desc: 'Suave y Estándar · Paralelo, Apertura y Mixta. La recomendada hoy es Estándar Mixta.', tiempo: 'Hoy', noLeido: true, icono: 'video' },
  { id: 2, tipo: 'Pilar comenta', titulo: 'Esta semana: foco en la apertura de pecho', desc: 'Un vídeo de 2 minutos donde Pilar explica en qué fijarte esta semana.', tiempo: 'Hoy', noLeido: true, icono: 'msg', dorado: true },
  { id: 3, tipo: 'Nuevo contenido', titulo: 'Nueva meditación: escaneo corporal', desc: '15 minutos para soltar tensión, ya disponible en Relajaciones.', tiempo: 'Hace 2 días', icono: 'circle' },
  { id: 4, tipo: 'Vida diaria', titulo: 'Nuevo consejo: ergonomía en el coche', desc: 'Cómo colocar el asiento para viajes largos sin cargar la espalda.', tiempo: 'Hace 4 días', icono: 'wave' },
  { id: 5, tipo: 'Entrevista', titulo: 'Postura y vida moderna, con Pilar', desc: 'Nueva entrevista de 25 minutos en "Conoce el Método".', tiempo: 'Hace 1 semana', icono: 'user', dorado: true },
];

export const BIBLIOTECA_CLASES = [
  { id: 1, nombre: 'Suave · Paralelo', nivel: 'Suave', modalidad: 'Paralelo', duracion: 18 },
  { id: 2, nombre: 'Suave · Apertura', nivel: 'Suave', modalidad: 'Apertura', duracion: 20 },
  { id: 3, nombre: 'Estándar · Paralelo', nivel: 'Estándar', modalidad: 'Paralelo', duracion: 22 },
  { id: 4, nombre: 'Estándar · Apertura', nivel: 'Estándar', modalidad: 'Apertura', duracion: 23 },
  { id: 5, nombre: 'Estándar · Mixta', nivel: 'Estándar', modalidad: 'Mixta', duracion: 24 },
  { id: 6, nombre: 'Suave · Mixta', nivel: 'Suave', modalidad: 'Mixta', duracion: 19 },
  { id: 7, nombre: 'Estándar · Paralelo intenso', nivel: 'Estándar', modalidad: 'Paralelo', duracion: 26 },
];

export const HORAS_SEMANALES = [5, 4, 5, 3, 5, 4, 2, 4, 5, 3];

export const ASISTENCIA_DIAS = {
  2:'pres',3:'onl',5:'onl',6:'pres',8:'onl',9:'pres',10:'onl',12:'onl',
  13:'pres',15:'onl',16:'onl',18:'pres',19:'onl',20:'pres',22:'onl',
  23:'pres',24:'onl',26:'onl',27:'pres',29:'onl',30:'pres',
};

// Tablón de anuncios (demo para preview sin backend)
export const ANUNCIO_DEMO = {
  activo: true,
  titulo: '¡Nueva clase disponible esta semana!',
  subtitulo: 'Ya puedes acceder a la clase Estándar Mixta desde la sección de clases.',
  mostrar_boton: true,
  texto_boton: 'Ver la clase',
  url_boton: '#',
};

// Botones del canal (demo para preview sin backend)
export const BOTONES_DEMO = [
  { id: 'b1', texto: 'Reservar presencial', url: '#', abrir_en_nueva_pestana: true },
  { id: 'b2', texto: 'Contacto', url: '#', abrir_en_nueva_pestana: false },
];
